import {QuantityType, TASK_QUANTITY_TYPE_OTHER} from "../../../../lib/src/api/dto/QuantityType"
import {Task} from "../../../../lib/src/api/dto/Task";
import {useCallback} from "react";
import {useApi} from "../../api/APIContext";

export const useTaskTypes = () => {
  const {quantityTypes} = useApi()

  const getQuantityType = useCallback((typeString: string|null|undefined) => {
    const type = typeString ?? TASK_QUANTITY_TYPE_OTHER
    return quantityTypes.find(qt => qt.id === type || qt.name === type)
  }, [quantityTypes])

  const isQuantityTypeOther = (quantityType: QuantityType): boolean => {
    return quantityType.id === TASK_QUANTITY_TYPE_OTHER || quantityType.name === TASK_QUANTITY_TYPE_OTHER
  }

  const roundQuantityThickness = (task: Task) => {
    if (!task.quantityThickness) {
      console.warn("This code shouldn't be accessible, unless something went wrong where quantityThickness could not be resolved.")
      return '0!'
    }

    if (task.thicknessUnit === 'cm') {
      return `${Math.round(task.quantityThickness! * 10) / 10}${task.thicknessUnit}`
    }  else {
      return `${Math.round(task.quantityThickness!)}${task.thicknessUnit}`
    }
  }

  const getTaskName = useCallback((task: Task): string => {
    const quantityType = getQuantityType(task.quantityType)
    if (quantityType === undefined || (isQuantityTypeOther(quantityType))) {
      if (task.quantityAmount !== null && task.quantityAmount > 0) {
        if (quantityType != null && !quantityType.hideArea) {
          return `${task.quantityAmount ?? 0}m² ${task.quantityThickness ? ` - ${roundQuantityThickness(task)}` : ''}` + (task.description.trim() === '' ? '' : ` · ${task.description}`)
        } else {
          return `${task.description}`
        }
      }
      return task.description
    }
    return (!quantityType.hideArea ? `${task.quantityAmount ?? 0}m² ${task.quantityThickness ? ` - ${roundQuantityThickness(task)}` : ''} ${quantityType.name}` : `${quantityType.name}`) + (task.description.trim() === '' ? '' : ` · ${task.description}`)
  }, [getQuantityType])

  const getTaskColor = useCallback((task: Task): string|null => {
    if (task.color) {
      return task.color
    }
    const quantityType = getQuantityType(task.quantityType)
    if (quantityType === undefined) {
      return null
    }
    return quantityType.defaultColor
  }, [getQuantityType])

  const getTaskTemplate = useCallback((taskType: string): string[]|null => {
    const quantityType = getQuantityType(taskType)
    if (quantityType === undefined) {
      return null
    }
    return quantityType.descriptionTemplate
  }, [getQuantityType])

  return {
    getTaskName,
    getTaskColor,
    getTaskTemplate: getTaskTemplate,
  }
}